import React, { useContext } from "react";

import Box from "../../UI/Box";
import { CustomizedStyled } from "./CustomizeStyled";

import CustomizedSlider from "./CustomizeSlider";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../Mixture/selectors";
import { getTenantCredentials } from "../Tenant/selectors";
import { toFixedNumber } from "../../utils/toFixedNumber";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import { getValueForKey } from "../../context/translationsUtils";
import {
  getCalculatedPrices,
  getCalculatedVolume,
  getCountryMeasureUnit,
} from "../Calculation/slice/selectors";
import CustomizeSelectWeight from "./CustomizeSelectWeight/CustomizeSelectWeight";
import CustomizeSelectJars from "./CustomizeSelectJars/CustomizeSelectJars";
import { formatCurrency } from "../../utils/formatCurrency";
import { MEASURE_UNIT } from "../../entities/Calculation";
import JarIcon from "../../UI/Icons/JarIcon";
import { getCalculatedJarFullness } from "../../utils/getCalculatedJarFullness";

const Customize: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const credentials = useSelector(getTenantCredentials);

  const { condiments = [], selectedWeight } = useSelector(getDataFromMixture);
  const { maxVolumeOfMix: maxWeight } = useSelector(getCalculatedVolume);
  const prices = useSelector(getCalculatedPrices);
  const countryMeasureUnit = useSelector(getCountryMeasureUnit);
  const fulness = getCalculatedJarFullness(selectedWeight, maxWeight);

  return (
    <CustomizedStyled>
      <Box className="no-space">
        <div className="customized-information">
          {getValueForKey(
            translations,
            "edit_mix.sidebar_step_2_set_weight_hint",
          )}
        </div>
        <div className="customized-ingredients">
          <span>{getValueForKey(translations, "edit_mix.ingredients")}:</span>
          {condiments.map((item) => (
            <span key={item.id}>{item.name},</span>
          ))}
        </div>
        <div className="customized-center">
          <div className="customize-picture">
            <JarIcon className={`mix-settings__icon ${fulness}`} />
          </div>

          <div className="customized-info">
            <div className="customized-info__left">
              <CustomizeSelectWeight />
              <CustomizeSelectJars />
            </div>
            <div className="customized-info__right">
              <div className="customized-price__group">
                <span>
                  {getValueForKey(translations, "edit_mix.sidebar_total_price")}
                </span>
                <span>
                  {formatCurrency({
                    amount: toFixedNumber(
                      prices.totalValueWithAllProperties,
                      2,
                    ),
                    country: credentials?.country,
                  })}
                </span>
              </div>
              <div className="customized-price__group">
                <span>
                  {getValueForKey(translations, "edit_mix.price_per", {
                    measure_unit: countryMeasureUnit,
                  })}
                </span>
                <span>
                  {formatCurrency({
                    amount:
                      countryMeasureUnit === MEASURE_UNIT.HundredGrams
                        ? toFixedNumber(prices.priceForOneHundredGrams, 2)
                        : toFixedNumber(prices.priceForOneKilogram, 2),
                    country: credentials?.country,
                  })}
                </span>
              </div>
            </div>
          </div>
        </div>

        <CustomizedSlider />
      </Box>
    </CustomizedStyled>
  );
};

export default Customize;
